import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class UpdateAISwapByRecordingUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (record: string, params: any): Promise<any> => {
        return await this._aiRepository.UpdateAISwapByRecord(record, params);
    }
}

export const UpdateAISwapByRecordingUseCaseName = "UpdateAISwapByRecordingUseCaseName";